import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from './pages/LandingPage'
import LegalMentions from './pages/LegalMentions';
import CGU from './pages/CGU';
import CGV from './pages/CGV';
import CGS from './pages/CGS';
import PolitiqueConfidentialite from './pages/PolitiqueConfidentialite';
import ServicesPage from './pages/ServicesPage';
import ContactPage from "./pages/ContactPage";
import ProjectsPage from "./pages/ProjectsPage";
import ScrollToTop from './components/ScrollToTop';
import ProjectDetailPage from "./pages/ProjectDetailPage";


const App = () => {
  return (
    <Router>
      <div className="bg-[#FFF]">
           <ScrollToTop />
        <Routes>
          <Route path='/' element={<LandingPage />} />
          <Route path='/mentions-legales' element={<LegalMentions />} />
          <Route path='/cgu' element={<CGU />} />
          <Route path='/cgv' element={<CGV />} />
          <Route path='/cgs' element={<CGS />} />
          <Route path='/politique-confidentialité' element={<PolitiqueConfidentialite />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/projects/:slug" element={<ProjectDetailPage />} />

        </Routes>
      </div>
    </Router>
  );
};

export default App;
